import React from "react";
import cashIcon from "../../../../assets/receptionistIcons/ipBilling/cash.svg";
import upiIcon from "../../../../assets/receptionistIcons/ipBilling/upi.svg";
import cardIcon from "../../../../assets/receptionistIcons/ipBilling/card.svg";
import chequeIcon from "../../../../assets/receptionistIcons/ipBilling/cheque.svg";
import impsIcon from "../../../../assets/receptionistIcons/ipBilling/imps.svg";
import rtgsIcon from "../../../../assets/receptionistIcons/ipBilling/rtgs.svg";
import neftIcon from "../../../../assets/receptionistIcons/ipBilling/neft.svg";
import othersIcon from "../../../../assets/receptionistIcons/ipBilling/others.svg";
import styles from "./BillingIp.module.css";

export const PAYMENT_MODES = [
  { value: "cash", label: "Cash", icon: cashIcon },
  { value: "upi", label: "UPI", icon: upiIcon },
  { value: "card", label: "Card", icon: cardIcon },
  { value: "cheque", label: "Cheque", icon: chequeIcon },
  { value: "imps", label: "IMPS", icon: impsIcon },
  { value: "rtgs", label: "RTGS", icon: rtgsIcon },
  { value: "neft", label: "NEFT", icon: neftIcon },
  { value: "others", label: "Others", icon: othersIcon },
];

const PaymentModeSelector = ({ value, onChange }) => {
  return (
    <div
      className={styles.paymentModes}
      role="group"
      aria-label="Payment mode"
    >
      {PAYMENT_MODES.map((mode) => {
        const isActive = value === mode.value;
        return (
          <button
            key={mode.value}
            type="button"
            aria-pressed={isActive}
            className={`${styles.modeBtn} ${isActive ? styles.modeBtnActive : ""}`}
            onClick={() => onChange?.(mode.value)}
          >
            <img src={mode.icon} alt="" className={styles.modeIcon} />
            <span>{mode.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PaymentModeSelector;
